import React from 'react'
import './styles/home.css';

const Photos = () => {
    return (
        <div id='photos-homepage'>
            <div id='photo-line'></div>
            <div id='phto-title-top'>
                <img src={process.env.PUBLIC_URL + 'images/camera-icon-gold.png'} className='camera-icon'></img>
                <h2>SEND US YOUR PHOTOS</h2>
            </div>

            <div id='photos-content'>
                <div id='photos-content-left'>
                    <img src={process.env.PUBLIC_URL + 'images/photos-image-2.png'} className='photos-image'></img>

                    <div id='send-us'>
                        <h2>SEND US</h2>
                        <h2>YOUR PHOTOS</h2>
                    </div>
                </div>
                <div id='photos-content-right'>
                    <h3>Say Cheese!</h3>
                    <p>
                        Step into the pulse of the show choir world, where music meets passion and the energy of fans lights up the room! This experience isn’t just about the dazzling performances on stage—it’s about the unforgettable moments in the crowd.

                        Get creative! Snap photos of fans decked out in their bold, colorful outfits, or capture the pure excitement radiating from their faces. Every snapshot tells a story, and we want to see yours!

                        Share your best moments with us on the Between Choirs Facebook page for a chance to be featured. Let’s showcase the spirit of show choir together through your lens. So grab your camera, join the fun, and help us celebrate the magic of these incredible events!
                    </p>
                    <a style={{ textDecoration: 'none', width: '100%' }} id="pht-btn-1" href='https://www.facebook.com/profile.php?id=61571698236116' target='_blank'>
                        <button className='gold-gradient-wshimmer' id='photos-button'>
                            Facebook Page
                        </button>
                    </a>

                </div>


            </div>

            <a id="pht-btn-2" style={{ textDecoration: 'none', width: '100%' }} href='https://www.facebook.com/profile.php?id=61571698236116' target='_blank'>
                <button className='gold-gradient-wshimmer' id='photos-button-2'>Facebook Page</button>
            </a>

            <div id='photos-line-2'></div>
        </div>
    )
}

export default Photos
